import { fromJS } from 'immutable'
import {
  STANDARD_PRICE_LIST_REQUEST,
  STANDARD_PRICE_LIST_SUCCESS,
  STANDARD_PRICE_LIST_FAILURE,
  STANDARD_PRICE_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_PRICE_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case STANDARD_PRICE_LIST_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('standardPrice', fromJS(action.payload.standard_prices))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case STANDARD_PRICE_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case STANDARD_PRICE_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-price/standard-price-list-reducer.js